import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

export default function BlogTags({ tags }) {
  if (isEmpty(tags)) return false;
  return (
    <div>
      {tags.map(tag =>
        <Link key={tag} className="blog-tag d-inline-block" to={`/blog?tag=${tag}`}>{tag}</Link>,
      )}
    </div>
  );
}

BlogTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
};

BlogTags.defaultProps = {
  tags: [],
};
